import React, { useEffect, useState } from 'react';
import Title from '../common/title';
import css from './dashboard.module.css';
import { useService } from '../../services/services';
import { useObservableState } from 'observable-hooks';
import SystemCheck, { SystemCheckRecord } from '../../interfaces/systemCheck';
import {
  faTimesCircle,
  faCheckCircle,
  faQuestionCircle,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactTooltip from 'react-tooltip';

export default function Dashboard() {
  const { healthService } = useService();

  const [healthCheck, setHealthCheck] = useState<SystemCheck>(null);

  const [checks] = useObservableState<SystemCheck>(
    () => healthService.check(),
    null
  );

  useEffect(() => {
    if (checks === null) {
      return;
    }

    setHealthCheck(checks);
  }, [checks, setHealthCheck]);

  function card(item: SystemCheckRecord) {
    return (
      <div
        className={`${css['status-card']} ${
          item.status === 'ok' ? css['is-ok'] : css['not-ok']
        }`}
      >
        <div className={css['status-icon']}>
          <FontAwesomeIcon
            icon={item.status === 'ok' ? faCheckCircle : faTimesCircle}
          />
        </div>
        <div className="w-full">
          <div className="font-bold">{item.label}</div>
          <div className="md:mt-1">
            {item.notificationMessage.length
              ? item.notificationMessage
              : item.shortSummary}
          </div>
        </div>
        {item.status !== 'ok' && JSON.stringify(item.meta) !== '[]' ? (
          <div className={css['meta-icon']}>
            <FontAwesomeIcon
              data-tip
              data-for={item.name}
              icon={faQuestionCircle}
              className="float-right"
            />
            <ReactTooltip
              id={item.name}
              backgroundColor="#002A58"
              place="top"
              effect="solid"
            >
              {JSON.stringify(item.meta)}
            </ReactTooltip>
          </div>
        ) : (
          ''
        )}
      </div>
    );
  }

  return (
    <div className={css['dashboard']}>
      <Title title="Laipni lūgti Manslauks.lv!" />
      <div className="grid grid-cols-1 gap-2 sm:gap-3 md:gap-5 md:grid-cols-2 lg:grid-cols-4">
        {healthCheck?.checkResults.map((item: SystemCheckRecord) => card(item))}
      </div>
    </div>
  );
}
